import { pacingNodesData } from '../components/PacingModal/data'
import { isV4Routed } from 'lib/api/ssapi/secondStepApi.router'
import { adaptNetSuiteAssetToLegacyLicense } from 'lib/api/adapters/sites'

const ADMIN = 'admin'

export const transformSiteData = () => {
  const instructorData = {
    HighSchool: {
      schoolwide: {
        lesson_nodes: [
          {
            leaf_node_id: 'wM06At1kR3sUWMIQ5WqfP',
            progress: 1,
            is_done: true,
            period_progress: null,
            is_complete: true,
            done_at: '2024-06-27T12:00:00.000Z',
            updated_by: 999,
            type: 'schoolwideTraining',
            time: '2024-06-27T15:30:36.000Z',
          },
        ],
        user_id: 999,
        site: 'siteId',
        registration_id: 123456,
        lesson_types: ['schoolwideTraining', 'schoolwidePractices'],
      },
      educatorTraining: {
        lesson_nodes: [
          {
            leaf_node_id: '4khx4l5Uc80GUKzhfYGC61',
            progress: 0,
            is_done: false,
            period_progress: null,
            is_complete: false,
            done_at: '2024-06-27T12:00:00.000Z',
            updatedBy: 999,
            type: 'trainingProgram',
            time: '2024-06-27T15:30:36.000Z',
          },
        ],
        user_id: 999,
        site: 'siteId',
        registration_id: 123456,
        lesson_types: ['trainingProgram', 'trainingCurriculum'],
      },
      educatorPractices: {
        lesson_nodes: [
          {
            leaf_node_id: '6e4GDhndQOyRi4tEcTq0M8',
            progress: 0,
            is_done: false,
            period_progress: null,
            is_complete: false,
            done_at: '2024-06-27T12:00:00.000Z',
            updatedBy: 999,
            type: 'trainingCurriculum',
            time: '2024-06-27T15:30:36.000Z',
          },
        ],
        user_id: 999,
        site: 'siteId',
        registration_id: 123456,
        lesson_types: ['educatorPractices', 'studentActivities'],
      },
    },
  }

  const highSchoolData = instructorData.HighSchool

  return {
    name: 'HighSchool',
    siteId: highSchoolData.schoolwide.site,
    schoolwide: {
      ...highSchoolData.schoolwide,
    },
    educatorTraining: {
      ...highSchoolData.educatorTraining,
    },
    educatorPractices: {
      ...highSchoolData.educatorPractices,
    },
  }
}

export const getMSOptInData = sites => {
  if (!sites) return []
  const useV4Assets = isV4Routed('getNetSuiteAssetsForUser')
  const useV4Sites = isV4Routed('getUserSites')

  return sites?.reduce((acc, site) => {
    const hasAdminClaim = Array.isArray(site?.claims)
      ? site.claims.some(claim => claim?.toLowerCase() === ADMIN)
      : false
    if (!hasAdminClaim) return acc

    // Preferences source differs between v3 and v4
    const hasMspPrefs = useV4Sites
      ? Array.isArray(site?.preferences)
      : !!site?.sitePreferences?.mspDigital
    if (!hasMspPrefs) return acc

    // Capability/license gating differs by route
    let hasMspCapability = false
    if (useV4Sites) {
      hasMspCapability = Array.isArray(site?.capabilities)
        ? site.capabilities.some(
            c => c?.name === 'MSP' && (c?.scope === 'platform' || !c?.scope),
          )
        : false
      if (!hasMspCapability) return acc
    } else {
      // Build candidate license list: v3 site.licenses plus adapted v4 assets when routed
      let candidateLicenses = Array.isArray(site?.licenses) ? site.licenses : []
      if (useV4Assets && Array.isArray(site?.netSuiteAssets)) {
        const adapted = site.netSuiteAssets
          .map(asset =>
            adaptNetSuiteAssetToLegacyLicense(asset, {
              id: site?.id,
              name: site?.name,
            }),
          )
          .filter(Boolean)
        candidateLicenses = [...adapted, ...candidateLicenses]
      }

      const nowIso = new Date().toISOString()
      hasMspCapability = candidateLicenses?.some(license => {
        const programCodes = license?.product?.programCodes || []
        const notExpired = license?.expirationDate > nowIso
        const notCancelled =
          license?.cancelledDate == null || license?.cancelledDate > nowIso
        return programCodes.includes('MSP') && notExpired && notCancelled
      })
      if (!hasMspCapability) return acc
    }

    if (hasMspCapability) {
      // Derive bullyingHarassmentUnitEnabled from the appropriate source
      let bullyingHarassmentUnitEnabled = false
      if (useV4Sites && Array.isArray(site?.preferences)) {
        const pref = site.preferences.find(
          p =>
            (p?.programCode === 'MSP' || p?.accessCode === 'mspDigital') &&
            p?.name === 'BullyingHarassmentUnitEnabled' &&
            (p?.assignmentType === 'Site' || !p?.assignmentType),
        )
        bullyingHarassmentUnitEnabled = !!pref?.value
      } else {
        bullyingHarassmentUnitEnabled = !!site?.sitePreferences?.mspDigital
          ?.bullyingHarassmentUnitEnabled
      }

      acc.push({
        name: site?.name,
        siteId: site?.id,
        sitePreferences: {
          mspDigital: {
            bullyingHarassmentUnitEnabled,
          },
        },
      })
    }
    return acc
  }, [])
}
export const calculateSitesWithBullyingUnitOnCount = mspSiteContexts => {
  const useV4Sites = isV4Routed('getUserSites')
  return mspSiteContexts?.reduce((sitesCount, currentSite) => {
    let enabled = false
    if (useV4Sites && Array.isArray(currentSite?.preferences)) {
      const pref = currentSite.preferences.find(
        p =>
          (p?.programCode === 'MSP' || p?.accessCode === 'mspDigital') &&
          p?.name === 'BullyingHarassmentUnitEnabled' &&
          (p?.assignmentType === 'Site' || !p?.assignmentType),
      )
      enabled = !!pref?.value
    } else {
      enabled = !!currentSite?.sitePreferences?.mspDigital
        ?.bullyingHarassmentUnitEnabled
    }

    if (enabled) {
      sitesCount++
    }
    return sitesCount
  }, 0)
}

export const setSitePreferencesCalculatedFields = (
  newSitePreferences,
  stateSite,
) => {
  const sitePreferences = { ...newSitePreferences }
  const sitePacing = stateSite?.pacing
  const schoolYearEndDate = stateSite?.schoolYearEndDate

  if (sitePreferences?.highSchool) {
    const { highSchool } = sitePreferences
    const highSchoolPacing = sitePacing?.highschool || sitePacing?.highSchool

    const isImplementationPlanComplete =
      !!highSchool?.implementationLevel &&
      !!highSchool?.implementationType &&
      highSchool?.studentActivities != null

    const hasTrainingPacingDate =
      highSchoolPacing?.findIndex(
        pacingDate =>
          pacingDate.nodeKey === pacingNodesData.highSchool.nodeTraining,
      ) > -1
    const hasCollection1PacingDate =
      highSchoolPacing?.findIndex(
        pacingDate => pacingDate.nodeKey === pacingNodesData.highSchool.node1,
      ) > -1
    const isPacingComplete =
      !!schoolYearEndDate && hasTrainingPacingDate && hasCollection1PacingDate

    const isSetup =
      isImplementationPlanComplete &&
      isPacingComplete &&
      highSchool?.areUsersAdded

    sitePreferences.highSchool = {
      ...sitePreferences.highSchool,
      isImplementationPlanComplete,
      isPacingComplete,
      isSetup,
    }
  }

  return sitePreferences
}

export const getUserContextProgramPreferences = (
  siteId,
  programName,
  stateUserContextSites,
) => {
  if (!stateUserContextSites || !siteId || !programName) {
    return null
  }
  const site = stateUserContextSites.find(site => site.siteId === siteId)
  return site?.programs[programName]
}
